<template>
    <div>
        <v-offline
                online-class="online"
                offline-class="offline"
                @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-sm-12">
                <h5>Records <i style="color: darkgrey" class="ti-angle-right small"></i> All Records</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <p>To search by date enter date in YYYY-MM-DD Format. Eg: 2024-01-31</p>
            </div>
            <div class="col-sm-12 col-xs-12 col-md-12 col-xl-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="!duplicateRecords.length" class="row set_row">
                            <!-- <div class="col-xl-1">
                            </div> -->
                            <div class="col-sm-12 col-xl-12 set_table_center">
                                <table id="notOperatedRecords" class="display table-striped table-bordered select"
                                       cellspacing="0" width="100%">
                                    <thead>
                                    <tr>
                                        <th><input type="checkbox" id="allCheckbox" @click="inputCheckBox"></th>
                                        <th>Caught Date</th>
                                        <th>Photo</th>
                                        <th>Collar ID</th>
                                        <th>Gender</th>
                                        <th>Operation Date</th>
                                        <th>Surgery Start Time</th>
                                        <th>Caught Method</th>
                                        <th>Surgeon Name</th>
                                        <th>Release Date</th>
                                        <th>Ownership</th>
                                        <th>Animal Name</th>
                                        <th>RFID</th>
                                        <th>App ID</th>
                                        <th>Species</th>
                                        <th>Area</th>
                                        <th>Caught Location</th>
                                        <th>Release Location</th>
                                        <th>Outcome</th>
                                        <th>Details</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                            <!-- <div class="col-xl-1">
                            </div> -->
                        </div>

                        <el-table
                            v-if="duplicateRecords.length"
                            :data="duplicateRecords"
                            style="width: 100%">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-table :data="props.row.records" border style="width: 100%">
                                        <el-table-column label="Image" prop="image_url">
                                            <template slot-scope="props">
                                                <img :src="props.row.image_url" width="100px" height="100px" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Caught Date" prop="caught_date"></el-table-column>
                                        <el-table-column label="Caught Method" prop="caught_method"></el-table-column>
                                        <el-table-column label="ownership" prop="ownership"></el-table-column>
                                        <el-table-column label="Age Category" prop="age_category"></el-table-column>
                                        <el-table-column label="Stage" prop="stage"></el-table-column>
                                        <el-table-column label="Outcome" prop="outcome"></el-table-column>
                                        <el-table-column label="Sterilisation Status" prop="sterilisation_status"></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column label="Collar Id" prop="collar_id"></el-table-column>
                            <el-table-column label="Caught Location" prop="caught_location"></el-table-column>
                            <el-table-column label="Total Duplicates" prop="total_duplicates"></el-table-column>
                        </el-table>
                    </div>
                    <div v-if="!isReadOnly && !duplicateRecords.length" class="card-footer">
                        <button v-bind:disabled="!onLine" class="btn btn-warning mr-2" type="button"
                                @click="showModal=true">Mark for Release
                        </button>
                        <button v-bind:disabled="!onLine" class="btn btn-warning edit_btn mr-2" type="button"
                                @click="changeStageOfSelectedRecords">
                            Change Stage
                        </button>
<!--                        <button v-bind:disabled="!onLine" class="btn btn-warning edit_btn" type="button" @click="editBulkRecords">-->
<!--                            Edit Selected Records-->
<!--                        </button>-->
                        <button type="button" class="btn mr-2" @click="archiveRecords">Archive</button>
                        <el-button type="primary" @click="showDuplicateRecords">Show Duplicate Records</el-button>
                    </div>
                    <div v-if="duplicateRecords.length && !isReadOnly" class="card-footer">
                        <el-button type="primary" @click="backToAllRecords" class="mr-2">Show All Records</el-button>
                        <button type="button" class="btn" @click="mergeDuplicateRecords">Merge Duplicate Records</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal pm-mark-for-release-modal fade" role="dialog" v-if="showModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header edit-header">
                        <h4 class="modal-title">To be released date</h4>
                    </div>
                    <div class="modal-body modal-body-noteoprated">
                        <FullCalendar
                                height="100"
                                content-height="100"
                                aspect-ratio="1.8"
                                defaultView="dayGridMonth"
                                :plugins="calendarPlugins"
                                :selectable="true"
                                @select="handleSelect"
                        />
                    </div>
                    <hr>
                    <div class="row set_footer">
                        <div class="col-md-8 selected-date">
                            <b>Selected Date :
                                {{ currentSelectDate != '' ? currentSelectDate : showDate.toLocaleDateString() }}</b>
                        </div>
                        <div class="col-md-4" style="text-align:right">
                            <button type="button" class="btn btn-default" style="background-color: var(--hw-danger) !important;"
                                    @click="showModal=false">Close
                            </button>
                            <button type="button" class="btn btn-default" style="background-color: var(--hw-pair1-secondary) !important;"
                                    @click="markForRelease">SUBMIT
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="showChangeStageDialog">
            <PmRecordStageChangerDialog
                :record-ids="selectedRecordIds"></PmRecordStageChangerDialog>
        </template>

    </div>
</template>
<script>
import mixin from '../../../../mixins/GlobalMixin';
import VOffline from 'v-offline';
import {Select, Option, Button} from 'element-ui';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'
import PmRecordStageChangerDialog from "../../../PmRecordStageChangerDialog";
import apiService from '../../../../services/api.service';
import Swal from 'sweetalert2';

export default {
    components: {
        [Option.name]: Option,
        [Select.name]: Select,
        [Button.name]: Button,
        FullCalendar,
        VOffline,
        PmRecordStageChangerDialog,
    },
    props: {
        projectId: {
            type: Number,
        }
    },
    data()
    {
        return {
            selectedRecordIds: [],
            showChangeStageDialog: false,

            isReadOnly:false,
            table: null,
            showModal: false,
            showDate: new Date(),
            currentSelectDate: '',
            calendarPlugins: [dayGridPlugin, interactionPlugin],
            duplicateRecords: []
        }
    },
    mixins: [mixin],
    methods: {
        changeStageOfSelectedRecords() {

            const vm = this
            vm.selectedRecordIds = []

            document.querySelectorAll('.check_input').forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true) {
                    vm.selectedRecordIds.push(element.value);
                }
            });

            if (vm.selectedRecordIds.length > 0) {
                vm.showChangeStageDialog = true
            } else {
                vm.showAlert('Alert', 'No records selected', false)
            }


        },
        addHealthRecordViewListener(editEl)
        {
            let vm = this;
            editEl[0].addEventListener('click', function () {
                let id = this.getAttribute("data-data");
                vm.$router.push({name: 'HealthRecordDetailsPm', params: {recordId: id}})
            }, false);
        },
        NotOperatedRecords()
        {
            let vm = this;

            if (vm.table != null) {
                vm.table.destroy();
            }
            try {
                vm.table = $('#notOperatedRecords').DataTable({
                    "columnDefs": [
                        {"visible": true, "targets": [19]}
                    ],
                    "order": [[1, "desc"]],
                    "scrollX": true,
                    responsive: true,
                    dom: 'lBfrtip',
                    "bInfo": false,
                    'columns': [
                        {
                            'targets': 0,
                            'render': function (data, type, full, meta) {
                                return '<span class="details-control" style="cursor: pointer; color: #337ab7; font-size: 18px; margin-right: 10px;">+</span>' +
                                       '<input type="checkbox" class="check_input" name="id[]" value="' + full[17] + '">';
                            },
                            'orderable': false
                        }, {
                            'targets': 1,
                            'render': function (data, type, full, meta) {
                                return vm.formatRecordDisplayDate(full[0], 'Do MMM YYYY, HH:mm:ss', ',');
                            }
                        }, {
                            'targets': 2,
                            'render': function (data, type, full, meta) {
                                return '<img src=' + full[1] + ' class="datatable_image_thumbnail" style="cursor: pointer; object-fit: cover;" height="70" width="70"/>';
                            },
                            'width': '9%'
                        }, {
                            'targets': 3,
                            'render': function (data, type, full, meta) {
                                return full[2];
                            }
                        }, {
                            'targets': 4,
                            'render': function (data, type, full, meta) {
                                return full[3];
                            }
                        },
                        {
                            'targets': 5,
                            'render': function (data, type, full, meta) {
                                return vm.formatRecordDisplayDate(full[4], 'Do MMM YYYY, HH:mm:ss', ',');
                            }
                        }, {
                            'targets': 6,
                            'render': function (data, type, full, meta) {
                                return full[5];
                            }
                        }, {
                            'targets': 7,
                            'render': function (data, type, full, meta) {
                                return full[6];
                            }
                        }, {
                            'targets': 8,
                            'render': function (data, type, full, meta) {
                                return full[7];
                            }
                        }, {
                            'targets': 9,
                            'render': function (data, type, full, meta) {
                                return full[8];
                            }
                        }, {
                            'targets': 10,
                            'render': function (data, type, full, meta) {
                                return full[9];
                            }
                        },{
                            'targets': 11,
                            'render': function (data, type, full, meta) {
                                return full[10];
                            }
                        }, {
                            'targets': 12,
                            'render': function (data, type, full, meta) {
                                return full[11];
                            }
                        }, {
                            'targets': 13,
                            'render': function (data, type, full, meta) {
                                return full[12]
                            }
                        }, {
                            'targets': 14,
                            'render': function (data, type, full, meta) {
                                return full[13]
                            }
                        },
                        {
                            'targets': 15,
                            'render': function (data, type, full, meta) {
                                return full[14]
                            }
                        },
                        {
                            'targets': 16,
                            'render': function (data, type, full, meta) {
                                return `<a href="https://www.google.com/maps/search/?api=1&query=${full[15]}" target="_blank">Map</a>`
                            }
                        },
                        {
                            'targets': 17,
                            'render': function (data, type, full, meta) {
                                return `<a href="https://www.google.com/maps/search/?api=1&query=${full[16]}" target="_blank">Map</a>`
                            }
                        },
                        {
                            'targets': 18,
                            'render': function (data, type, full, meta) {
                                return full[17]
                            }
                        },
                        {
                            'targets': 19,
                            'render': function (data, type, full, meta) {
                                if (vm.isReadOnly) {
                                    return '<button type="button" class="btn btn-warning viewHealthRecordDetails" data-data="' + full[18] + '">View</button>';
                                }
                                return '<button type="button" class="btn btn-warning viewHealthRecordDetails" data-data="' + full[18] + '">View/Edit</button>';
                            }
                        },

                    ],
                    buttons: [
                        {
                            extend: 'excel',
                            text: 'Export to excel',
                            className: 'btn btn-default',
                            action: function (e, dt, button, config) {
                                vm.exportToExcelWithTreatments();
                            }
                        },
                        {
                            extend: 'colvis',
                            text: 'Filter Columns',
                            className: 'btn btn-default'
                        }
                    ],
                    "processing": true,
                    "serverSide": true,
                    "ajax": {
                        "url": window.DATATABLES_BASE_URL + "records/allPmRecords",
                        "type": "POST",
                        "data": {
                            project_id: vm.projectId,
                        }
                    },
                    'fnRowCallback': function (nRow, aData, iDisplayIndex) {
                        const viewEditBtn = $('.viewHealthRecordDetails', nRow);
                        vm.addHealthRecordViewListener(viewEditBtn);
                        const imageElement = $('.datatable_image_thumbnail', nRow);
                        vm.zoomImagePopup(imageElement);

                        // Add expand/collapse click handler
                        const detailsControl = $('.details-control', nRow);
                        detailsControl.off('click').on('click', function () {
                            const tr = $(this).closest('tr');
                            const row = vm.table.row(tr);
                            const catchReleaseId = aData[17]; // ID is in column 17

                            if (row.child.isShown()) {
                                // This row is already open - close it
                                row.child.hide();
                                tr.removeClass('shown');
                                $(this).html('+');
                            } else {
                                // Open this row and show treatments
                                vm.loadTreatments(catchReleaseId, row, $(this));
                                tr.addClass('shown');
                                $(this).html('-');
                            }
                        });

                        return nRow;
                    },
                    lengthMenu: [[15, 100, -1], [15, 100, "All (Warning: Slow)"]],
                    pageLength: 15,
                    fixedHeader: {
                        header: true,
                        headerOffset: 60
                    },
                });
            } catch (e) {
                console.log(e)
            }
        },
        editViewRecord()
        {
            var self = this;
            var editIcon = document.querySelectorAll('.view_edit');
            for (var i = 0; i < editIcon.length; i++) {
                editIcon[i].addEventListener('click', function () {
                    window.location = '/project/mark_release/' + self.projectId;
                }, false);
            }
        },
        inputCheckBox()
        {
            if (document.getElementById('allCheckbox').checked) {
                console.log("if");
                document.querySelectorAll('.check_input').forEach(function (element) {
                    element.checked = true;
                });
            } else {
                console.log("else");
                document.querySelectorAll('.check_input').forEach(function (element) {
                    element.checked = false;
                });
            }
        },
        setShowDate(date)
        {
            this.showDate = date;
        },
        handleSelect(e)
        {
            let date = new Date(e.start);
            let fDate = (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear())
            this.currentSelectDate = fDate;
        },
        markForRelease()
        {
            let catch_release_record_ids = [];
            let selectDate;
            let vm = this;
            if (vm.currentSelectDate == '') {
                let date = new Date(vm.showDate);
                let fDate = (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear())
                selectDate = fDate;
            } else {
                selectDate = vm.currentSelectDate;
            }
            document.querySelectorAll('.check_input').forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true) {
                    var checkInputValue = element.value;
                    catch_release_record_ids.push(checkInputValue);
                    axios.post('catch_release/mark_for_release', {
                        catch_release_record_ids: catch_release_record_ids,
                        release_date: selectDate,
                    }).then(response => {
                        if (response.data.response.error.error_code === 0) {
                            vm.showModal = false;
                            vm.showAlert('Success', response.data.response.error.msg, true);
                            vm.NotOperatedRecords();
                        }
                    }).catch(error => {
                        vm.showAlert('Error', error.response.data.response.error.error_msg, false);
                    })
                }
            })
            if (catch_release_record_ids.length == 0) {
                vm.showModal = false;
                vm.showAlert('Alert', 'Please select record(s)', false);
            }
        },
        editBulkRecords() {
            const selectedRecords = []
            document.querySelectorAll('.check_input').forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true) {
                    selectedRecords.push(element.value);
                }
            });
            this.$router.push({name: 'EditBulkRecords', query: { ref: 'all', selectedRecordIds: JSON.stringify(selectedRecords), fromText: 'All Records' }})
        },
        async archiveRecords() {
            const vm = this;
            const selectedRecordIds = [];
            document.querySelectorAll('.check_input').forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true) {
                    selectedRecordIds.push(element.value);
                }
            });

            if (selectedRecordIds.length > 0) {
                const loading = vm.$loading({
                    lock: true,
                    text: 'Archiving records...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const apiResponse = await apiService.archivePmRecords({ids: selectedRecordIds});

                loading.close();
                if (apiResponse.response.error.error_code === 0) {
                    vm.showModal = false;
                    vm.showAlert('Success', apiResponse.response.error.msg, true);
                    vm.NotOperatedRecords();
                } else {
                    vm.showAlert('Error', apiResponse.response.error.error_msg, false);
                }
            } else {
                vm.showAlert('Alert', 'No records selected', false)
            }
        },
        async showDuplicateRecords() {
            const vm = this;
            const loading = vm.$loading({
                lock: true,
                text: 'Featching duplicate records...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const apiResponse = await apiService.getDuplicateRecords(vm.projectId);

            loading.close();
            if (apiResponse.response.error.error_code === 0) {
                vm.duplicateRecords = apiResponse.response.data.duplicates;
                if (!vm.duplicateRecords.length) {
                    vm.showAlert('Alert', 'No duplicate records found', true);
                }
            } else {
                vm.showAlert('Error', apiResponse.response.error.error_msg, false);
            }
        },
        mergeDuplicateRecords() {
            const vm = this;
            new Swal({
                icon:'info',
                title: 'Are you sure?',
                text: 'This action will delete duplicate records',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Merge',
                buttonsStyling: false,
            }).then(function (result) {
                if (result.value) {
                    const loading = vm.$loading({
                        lock: true,
                        text: 'Merging duplicate records...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    apiService.mergeDuplicateRecords(vm.projectId)
                    .then(apiResponse => {
                        loading.close();
                        if (apiResponse.data.response.error.error_code == 0) {
                            vm.showAlert('Success', apiResponse.data.response.error.msg, true);
                            vm.showDuplicateRecords();
                        } else {
                            vm.showAlert('Error', apiResponse.response.error.error_msg, false);
                        }
                    })
                    .catch(error => {
                        loading.close();
                        vm.showAlert('Error', apiResponse.response.error.error_msg, false);
                    });
                }
            });
        },
        backToAllRecords() {
            const vm = this;
            vm.duplicateRecords = [];
            setTimeout(() => {
                vm.NotOperatedRecords();
            });
        },

        async loadTreatments(catchReleaseId, row, controlElement) {
            const vm = this;

            // Show loading indicator
            controlElement.html('<i class="fa fa-spinner fa-spin"></i>');

            try {
                const response = await axios.post(window.DATATABLES_BASE_URL + 'treatments/by/catch_release_id', {
                    catch_release_id: catchReleaseId
                });

                if (response.data.success) {
                    const treatments = response.data.data;
                    const treatmentHtml = vm.formatTreatmentDetails(treatments);
                    row.child(treatmentHtml).show();
                    controlElement.html('-');
                } else {
                    vm.showAlert('Error', 'Failed to load treatments', false);
                    controlElement.html('+');
                }
            } catch (error) {
                console.error('Error loading treatments:', error);
                vm.showAlert('Error', 'Failed to load treatments', false);
                controlElement.html('+');
            }
        },

        formatTreatmentDetails(treatments) {
            if (!treatments || treatments.length === 0) {
                return '<div class="treatment-details"><p style="text-align: center; color: #666; font-style: italic;">No treatments found for this record.</p></div>';
            }

            let html = '<div class="treatment-details">';
            html += '<div class="table-responsive" style="margin-bottom: 0px;">';
            html+='<h6 class="text-left">Treatments</h6>';
            html += '<table class="table table-striped table-sm" style="margin-bottom: 0px;">';
            html += '<thead><tr>';
            html += '<th>Date</th>';
            html += '<th>Type</th>';
            html += '<th>Vet Name</th>';
            html += '<th>Drugs Given</th>';
            html += '<th>Vaccinations</th>';
            html += '<th>Notes</th>';
            html += '<th>Post-Op Complications</th>';
            html += '</tr></thead><tbody>';

            treatments.forEach(treatment => {
                html += '<tr>';
                html += `<td>${this.formatRecordDisplayDate(treatment.treatment_date, 'Do MMM YYYY')}</td>`;
                html += `<td>${this.formatTreatmentType(treatment.treatment_type)}</td>`;
                html += `<td>${treatment.vet_name || '-'}</td>`;
                html += `<td>${this.formatDrugsGiven(treatment.drugs_given)}</td>`;
                html += `<td>${this.formatVaccinations(treatment.vaccinations_given)}</td>`;
                html += `<td>${treatment.note || treatment.treatment_other_note || '-'}</td>`;
                html += `<td>${treatment.post_op_complication == 1 ? 'Yes' : 'No'}</td>`;
                html += '</tr>';
            });

            html += '</tbody></table>';
            html += '</div></div>';

            return html;
        },

        formatTreatmentType(typeData) {
            if (!typeData || typeData === '' || typeData === 'null') {
                return '-';
            }

            try {
                const types = JSON.parse(typeData);
                if (!Array.isArray(types) || types.length === 0) {
                    return typeData; // Return original if not array
                }

                return types.join(' | ');

            } catch (error) {
                console.error('Error parsing treatment type data:', error);
                return typeData; // Return original if parsing fails
            }
        },

        formatVaccinations(vaccinationData) {
            if (!vaccinationData || vaccinationData === '' || vaccinationData === 'null') {
                return '-';
            }

            try {
                const vaccinations = JSON.parse(vaccinationData);
                if (!Array.isArray(vaccinations) || vaccinations.length === 0) {
                    return vaccinationData; // Return original if not array
                }

                return vaccinations.join(' | ');

            } catch (error) {
                console.error('Error parsing vaccination data:', error);
                return vaccinationData; // Return original if parsing fails
            }
        },

        formatDrugsGiven(drugsData) {
            if (!drugsData || drugsData === '' || drugsData === 'null') {
                return '-';
            }

            try {
                const drugs = JSON.parse(drugsData);
                if (!Array.isArray(drugs) || drugs.length === 0) {
                    return '-';
                }

                return drugs.map(drug => {
                    const name = drug.drugName || '';
                    const dose = drug.dose || '';
                    const unit = drug.unit || '';
                    return `${name} ${dose}${unit}`;
                }).join(' | ');

            } catch (error) {
                console.error('Error parsing drugs data:', error);
                return drugsData; // Return original if parsing fails
            }
        },

        formatExportDrugs(allDrugsData) {
            if (!allDrugsData || allDrugsData === '' || allDrugsData === 'null') {
                return '-';
            }

            try {
                // Split by semicolon to get individual JSON arrays
                const drugGroups = allDrugsData.split(';').map(group => group.trim()).filter(group => group);

                const formattedGroups = drugGroups.map(group => {
                    try {
                        const drugs = JSON.parse(group);
                        if (!Array.isArray(drugs) || drugs.length === 0) {
                            return '';
                        }

                        const formattedDrugs = drugs.map(drug => {
                            const name = drug.drugName || '';
                            const dose = drug.dose || '';
                            const unit = drug.unit || '';
                            return `${name} ${dose}${unit}`;
                        }).join(' | ');

                        return `[${formattedDrugs}]`;
                    } catch (error) {
                        return group; // Return original if parsing fails
                    }
                }).filter(group => group);

                return formattedGroups.join(', ');

            } catch (error) {
                console.error('Error formatting export drugs data:', error);
                return allDrugsData; // Return original if parsing fails
            }
        },

        formatExportVaccinations(allVaccinationsData, rabiesVaccine) {
            const rabiesLabel = this.formatRabiesVaccine(rabiesVaccine);

            if (!allVaccinationsData || allVaccinationsData === '' || allVaccinationsData === 'null') {
                return rabiesLabel || '-';
            }

            try {
                // Split by semicolon to get individual JSON arrays
                const vaccinationGroups = allVaccinationsData.split(';').map(group => group.trim()).filter(group => group);

                const formattedGroups = vaccinationGroups.map(group => {
                    try {
                        const vaccinations = JSON.parse(group);
                        if (!Array.isArray(vaccinations) || vaccinations.length === 0) {
                            return '';
                        }

                        const formattedVaccinations = vaccinations.map(vaccination => {
                            return vaccination.vaccinationName || vaccination;
                        }).join(' | ');

                        return `[${formattedVaccinations}]`;
                    } catch (error) {
                        return group; // Return original if parsing fails
                    }
                }).filter(group => group);

                const treatmentsPart = formattedGroups.join(', ');

                if (rabiesLabel && treatmentsPart) {
                    return `${rabiesLabel}, ${treatmentsPart}`;
                }
                return rabiesLabel || treatmentsPart || '-';

            } catch (error) {
                console.error('Error formatting export vaccinations data:', error);
                return allVaccinationsData; // Return original if parsing fails
            }
        },

        formatRabiesVaccine(rabiesVaccine) {
            if (!rabiesVaccine || rabiesVaccine === '' || rabiesVaccine === 'null' ||
                rabiesVaccine === '0' || rabiesVaccine === 0 ||
                rabiesVaccine === false || rabiesVaccine === 'false') {
                return '';
            }
            if (rabiesVaccine === '1' || rabiesVaccine === 1 ||
                rabiesVaccine === true || rabiesVaccine === 'true') {
                return '[Rabies: Vaccination Given]';
            }
            return `[Rabies: ${rabiesVaccine}]`;
        },

        async exportToExcelWithTreatments() {
            const vm = this;

            // Show loading indicator
            const loading = vm.$loading({
                lock: true,
                text: 'Preparing Excel export with treatment details...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                const response = await axios.post(window.DATATABLES_BASE_URL + 'records/allPmRecordsWithTreatments', {
                    project_id: vm.projectId
                });

                if (response.data.success) {
                    const records = response.data.data;
                    vm.generateExcelFile(records);
                } else {
                    vm.showAlert('Error', 'Failed to fetch records for export', false);
                }
            } catch (error) {
                console.error('Error exporting to Excel:', error);
                vm.showAlert('Error', 'Failed to export data', false);
            } finally {
                loading.close();
            }
        },

        generateExcelFile(data) {
            // Safely format a date for CSV: returns '' for null/empty/invalid inputs
            const safeDate = (value, format) => {
                if (value === null || value === undefined || value === '' ||
                    value === '0000-00-00 00:00:00' || value === 'null') {
                    return '';
                }
                const formatted = this.formatRecordDisplayDate(value, format);
                if (formatted === null || formatted === undefined ||
                    formatted === 'Invalid date' || formatted === 'Invalid Date') {
                    return '';
                }
                return formatted;
            };

            // Create CSV content
            const headers = [
                'Caught Date', 'Collar ID', 'Gender', 'Operation Date', 'Surgery Start Time',
                'Caught Method', 'Surgeon Name', 'Release Date', 'Ownership','Animal Name', 'RFID',
                'App ID', 'Species', 'Area', 'Caught Location', 'Release Location', 'Outcome',
                'Treatment Count', 'Treatment Types', 'Latest Treatment Date', 'Vet Names',
                'All Drugs Given', 'All Vaccinations Given', 'Post-Op Complications', 'All Treatments'
            ];

            let csvContent = headers.join(',') + '\n';

            data.forEach(record => {
                const row = [
                    safeDate(record.caught_date, 'Do MMM YYYY'),
                    record.collar_id || '',
                    record.gender || '',
                    safeDate(record.operation_date, 'Do MMM YYYY'),
                    record.surgery_start_time || '',
                    record.caught_method || '',
                    record.surgeon_name || '',
                    safeDate(record.release_date, 'Do MMM YYYY'),
                    record.ownership || '',
                    record.animal_name || '',
                    record.rf_id || '',
                    record.hsapps_id || '',
                    record.species || '',
                    record.area_name || '',
                    record.caught_location || '',
                    record.dropoff_lat_lng || '',
                    record.outcome || '',
                    record.treatment_count || '0',
                    record.treatment_types || '',
                    safeDate(record.latest_treatment_date, 'Do MMM YYYY'),
                    record.vet_names || '',
                    this.formatExportDrugs(record.all_drugs_given),
                    this.formatExportVaccinations(record.all_vaccinations_given, record.rabies_vaccine),
                    record.post_op_complications || '',
                    record.all_treatments || ''
                ].map(field => `"${String(field).replace(/"/g, '""')}"`);

                csvContent += row.join(',') + '\n';
            });

            // Create and download file
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `pm_records_with_treatments_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
    computed: {},
    mounted()
    {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;

        vm.projectId = vm.project.id;

        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if(r.role_name == 'VIEWER'){
                vm.isReadOnly = true
            }
        })

        window.Bus.$on('pm-close-stage-changer-dialog-box', function () {
            vm.showChangeStageDialog = false

            vm.NotOperatedRecords();
        })

        //Bus.$emit("projectype", vm.project);
        vm.NotOperatedRecords();
    }
}

</script>
<style lang="scss">
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';

.containBytitile h4 {
  font-size: 1.2em;
  line-height: 1.45em;
}

@media (max-width: 425px) {
  .edit_btn {
    margin-top: 10px !important;
  }
}

/* Treatment details styling */
.treatment-details {
  background-color: #f8f9fa;
}

.treatment-details h5 {
  color: #337ab7;
  font-weight: 600;
}

.treatment-details .table {
  background-color: white;
}

.treatment-details .table th {
  background-color: #337ab7;
  color: white;
  font-weight: 600;
  border: none;
  padding: 1px 8px;
  font-size: 0.85rem;
}

.treatment-details .table td {
  padding: 1px 8px;
  font-size: 0.85rem;
  border-color: #dee2e6;
}

.treatment-details .table-striped tbody tr:nth-of-type(odd) {
  background-color: #f8f9fa;
}

/* Expand/collapse button styling */
.details-control {
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  user-select: none;
  transition: color 0.3s ease;
}

.details-control:hover {
  color: #23527c !important;
}
</style>
